import {BASE_TRACK_API_URL} from '@constants/config'
import {apiRequestWithAuth} from '@helpers/query/apiRequestWithAuth'
import {OnShowError} from '@baseTypes/base'
import {serialize} from '@helpers/query/serialize'
import {
	IPassengerChartRoute,
	IPassengerChartRouteSummary
} from '@containers/monitoringPlatform/passengerCharts/types'

const BASE_URL_ACCOUNTS = `${BASE_TRACK_API_URL}/v1/accounts`

export const getPassengerChartRoutesApi = async (
	accountId: number,
	date: string,
	onError?: OnShowError
): Promise<IPassengerChartRouteSummary[]> => {
	const url = `${BASE_URL_ACCOUNTS}/${accountId}/passenger-charts/routes?` + serialize({date})
	return await apiRequestWithAuth<IPassengerChartRouteSummary[]>({
		url,
		options: {
			method: 'GET',
		},
		onError
	})
}

export const getPassengerChartRouteApi = async (
	accountId: number,
	routeId: number,
	date: string,
	onError?: OnShowError
): Promise<IPassengerChartRoute> => {
	const url = `${BASE_URL_ACCOUNTS}/${accountId}/passenger-charts/routes/${routeId}?` + serialize({date})
	return await apiRequestWithAuth<IPassengerChartRoute>({
		url,
		options: {
			method: 'GET',
		},
		onError
	})
}
